import {
  List,
  Datagrid,
  NumberField,
  DateField,
  FunctionField,
  ReferenceInput,
  Filter,
  AutocompleteInput,
  ReferenceField
} from "react-admin";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

const createdFromChoises = [
  { id: "MANUALLY_ADMIN", name: "Administrateur" },
  { id: "MANUALLY_PROVIDER", name: "Prestataire" },
  { id: "OUTLET", name: "Exutoire" },
  { id: "ORDER", name: "Bon de commande" },
];

const createdFromLabels: Record<string, string> = createdFromChoises.reduce(
  (acc, { id, name }) => ({ ...acc, [id]: name }),
  {}
);

const ProviderInventoryFilter: React.FC = (props) => (
  <Filter {...props}>
    <ReferenceInput
      source="provider"
      reference="providers"
      perPage={50}
      label="Prestataire"
    >
      <AutocompleteInput
        optionText={(record) => `${record.internalCode} - ${record.name}`}
        fullWidth
        label="Prestataire"
        filterToQuery={(searchText: any) => ({
          filterTree: {
            operator: "or",
            operands: [
              {
                term: {
                  name: "name",
                  filterType: "like",
                  value: searchText,
                },
              },
              {
                term: {
                  name: "internalCode",
                  filterType: "like",
                  value: searchText,
                },
              },
            ],
          },
        })}
      />
    </ReferenceInput>
  </Filter>
);

export const ProviderInventoryList: React.FC = (props) => {
  return (
    <List
      {...props}
      resource="provider-inventory"
      sort={{ field: "createdAt", order: "DESC" }}
      filters={<ProviderInventoryFilter />}
      title="Inventaire des prestataires"
    >
      <Datagrid>
        <ReferenceField
          label="Prestataire"
          source="provider"
          reference="providers"
          link={false}
        >
          <FunctionField render={(record) => record.name} />
        </ReferenceField>
        <NumberField source="airbagsCount" label="Nb airbag" />
        <NumberField source="fullBinsCount" label="Caisses pleines" />
        <NumberField source="emptyBinsCount" label="Caisses vides" />
        <DateField
          source="createdAt"
          label="Date création"
          locales="fr-FR"
          options={{
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }}
        />
        <FunctionField
          source="createdFrom"
          label="Ajouté par"
          render={(record) =>
            createdFromLabels[record.createdFrom] || record.createdFrom
          }
        />
        <FunctionField
          label="Inventaire"
          render={(record) => (
            <Button
              component={Link}
              to={`/provider-inventory/details/${record.provider}`}
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              Voir
            </Button>
          )}
        />
      </Datagrid>
    </List>
  );
};
